// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat {
	grid-area: chat;
	display: inline-flex;
	position: relative;
	white-space: nowrap;
	justify-content: right;
	align-items: center;
	overflow: visible;
	flex: 0 0 auto;
	gap: 0.2em;
}

.chat > * {
	display: inline-block;
}

@media (max-width: 900px) {
	.chat input {
		width: 14.5em;
	}
}

@media (min-width: 900px) {
	.chat {
		width: 7.2em;
		flex: 0 0 7.2em;
	}

	.chat input {
		width: 6em;
		transition: width 0.2s ease-in-out;
	}

	.chat input:focus {
		width: 14.5em;
		position: relative;
		z-index: 1;
	}
}

@media (min-width: 1600px) {
	.chat {
		width: fit-content;
		flex: 0 0 auto;
	}
	.chat input {
		width: 14.5em;
	}
}

.chat-bubble {
	pointer-events: none;
	position: absolute;
	left: calc(1em);
	top: calc(100% + 0.5em);
	background: #fff;
	color: black;
	border: solid 2px #000;
	padding: 0.25em;
	padding-left: 0.5em;
	padding-right: 0.5em;
	border-radius: 0.2em;
	opacity: 0;
	min-width: 100%;
	max-width: 50vw;
	max-height: 60vh;
	z-index: 2;
	word-wrap: break-word;

	transition: opacity 0.2s;
}

.chat-bubble:after {
	content: "";
	position: absolute;
	top: 0;
	left: 1em;
	width: 0;
	height: 0;
	border: 14px solid transparent;
	border-bottom-color: #fff;
	border-top: 0;
	border-left: 0;
	margin-left: -7px;
	margin-top: -14px;
}
`, "",{"version":3,"sources":["webpack://./client/src/css/chat.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;CACnB,sBAAsB;CACtB,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;CACd,UAAU;AACX;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,UAAU;EACV,kCAAkC;CACnC;;CAEA;EACC,aAAa;EACb,kBAAkB;EAClB,UAAU;CACX;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,cAAc;CACf;CACA;EACC,aAAa;CACd;AACD;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,eAAe;CACf,uBAAuB;CACvB,gBAAgB;CAChB,YAAY;CACZ,sBAAsB;CACtB,eAAe;CACf,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,UAAU;CACV,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,qBAAqB;;CAErB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,QAAQ;CACR,SAAS;CACT,8BAA8B;CAC9B,yBAAyB;CACzB,aAAa;CACb,cAAc;CACd,iBAAiB;CACjB,iBAAiB;AAClB","sourcesContent":[".chat {\n\tgrid-area: chat;\n\tdisplay: inline-flex;\n\tposition: relative;\n\twhite-space: nowrap;\n\tjustify-content: right;\n\talign-items: center;\n\toverflow: visible;\n\tflex: 0 0 auto;\n\tgap: 0.2em;\n}\n\n.chat > * {\n\tdisplay: inline-block;\n}\n\n@media (max-width: 900px) {\n\t.chat input {\n\t\twidth: 14.5em;\n\t}\n}\n\n@media (min-width: 900px) {\n\t.chat {\n\t\twidth: 7.2em;\n\t\tflex: 0 0 7.2em;\n\t}\n\n\t.chat input {\n\t\twidth: 6em;\n\t\ttransition: width 0.2s ease-in-out;\n\t}\n\n\t.chat input:focus {\n\t\twidth: 14.5em;\n\t\tposition: relative;\n\t\tz-index: 1;\n\t}\n}\n\n@media (min-width: 1600px) {\n\t.chat {\n\t\twidth: fit-content;\n\t\tflex: 0 0 auto;\n\t}\n\t.chat input {\n\t\twidth: 14.5em;\n\t}\n}\n\n.chat-bubble {\n\tpointer-events: none;\n\tposition: absolute;\n\tleft: calc(1em);\n\ttop: calc(100% + 0.5em);\n\tbackground: #fff;\n\tcolor: black;\n\tborder: solid 2px #000;\n\tpadding: 0.25em;\n\tpadding-left: 0.5em;\n\tpadding-right: 0.5em;\n\tborder-radius: 0.2em;\n\topacity: 0;\n\tmin-width: 100%;\n\tmax-width: 50vw;\n\tmax-height: 60vh;\n\tz-index: 2;\n\tword-wrap: break-word;\n\n\ttransition: opacity 0.2s;\n}\n\n.chat-bubble:after {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\tleft: 1em;\n\twidth: 0;\n\theight: 0;\n\tborder: 14px solid transparent;\n\tborder-bottom-color: #fff;\n\tborder-top: 0;\n\tborder-left: 0;\n\tmargin-left: -7px;\n\tmargin-top: -14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
